import React from "react";

const Link = ({ settings, className: additionalClassName, children }) => {
  const { label, link, id, className, target, rel } = settings;

  return (
    <a
      href={link}
      className={[className, additionalClassName].filter(Boolean).join(' ')}
      id={id ? id : ""}
      target={target}
      rel={rel}
      title={label}
    >
      {children || label}
    </a>
  );
};

export default Link;
